export const LAST_CLICKED_RECOMMENDED_AGENT_KEY = 'rovoLastClickedRecommendedAgent';
export const ROVO_AGENTS_FE_TEAM_NAME = 'rovo-agents-fe';
